import { createPopper } from '@popperjs/core';

export default class Tooltip {
	constructor(tooltipButton) {
		this.tooltipButton = tooltipButton;
		this.text = JSON.parse(tooltipButton.dataset.tooltipText);
		this.title = JSON.parse(tooltipButton.dataset.tooltipTitle);

		this.tooltip = document.createElement('div');
		this.tooltip.classList.add('c-tooltip');

		const content = `
			<button class="c-tooltip__close"><span></span><span></span></button>
			${this.title ? `<div class="c-tooltip__title">${this.title}</div>` : ``}
			<div class="c-tooltip__text">${this.text}</div>
		`;

		this.tooltip.insertAdjacentHTML('beforeend', content);

		document.body.appendChild(this.tooltip);

		this.popperInstance = createPopper(this.tooltipButton, this.tooltip, {
			placement: 'top',
			modifiers: [
				{
					name: 'offset',
					options: {
						offset: [0, 20],
					},
				},
			],
		});

		this.tooltip.addEventListener('click', (e) => {
			if (e.target.closest('.c-tooltip__close')) {
				this.hide();
			}
		});

		this.tooltipButton.addEventListener('click', (e) => {
			const show = this.tooltip.hasAttribute('data-show');

			show ? this.hide() : this.show();
		});
	}

	show() {
		this.tooltip.setAttribute('data-show', '');

		this.popperInstance.setOptions((options) => ({
			...options,
			modifiers: [...options.modifiers, { name: 'eventListeners', enabled: true }],
		}));

		this.popperInstance.update();
	}

	hide() {
		this.tooltip.removeAttribute('data-show', '');

		this.popperInstance.setOptions((options) => ({
			...options,
			modifiers: [...options.modifiers, { name: 'eventListeners', enabled: false }],
		}));
	}

	static init() {
		const tooltipButtons = document.querySelectorAll('[data-tooltip-content]');

		tooltipButtons.forEach((tooltipButton) => {
			new Tooltip(tooltipButton);
		});
	}
}
